// extracted by mini-css-extract-plugin
module.exports = {"loadingText":"loadingText--ijd3vhlv","fadeIn":"fadeIn--OOrqFdeC","fadeOut":"fadeOut--rxVm2Zc7"};